export function customerTags(state = [], action) {
    switch (action.type) {
    case 'CUSTOMER TAG LIST':
        return action.data;
    default:
        return state;
    }
}